/** 
 * All clubs page
 */
import React from "react";
import LinkCard from "../components/core/LinkCard";
import { useQuery } from "@tanstack/react-query";
import CoreBanner from "../components/core/CoreBanner";
import Container from "../components/core/Container";
import { Helmet } from "react-helmet-async";
import Loading from "../components/core/Loading";

const ClubsHero = () => {
  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["clubs"],
    queryFn: () =>
      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/club/all/`).then((res) =>
        res.json()
      ),
  });

  if (isLoading)
    return (
        <>
            <CoreBanner title="BUIHA Clubs" />
            <Container>
                <Loading/>
            </Container>
        </>
    );
    

  if (error) return "An error has occurred: " + error.message;

  data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <div className="flex flex-row flex-wrap justify-center items-center">
      <Helmet>
        <title>All Clubs | BUIHA</title>
        <meta
          name="description"
          content={`All member clubs within the British Universities Ice Hockey Association (BUIHA)`}
        />
        <link rel="canonical" href={`https://buiha.org/clubs`} />
        <link rel="icon" type="image/png" href="/favicon.png" />
        {/* Add favicon */}
      </Helmet>

      <CoreBanner title="BUIHA Clubs" />

      <Container
        children={
          <div className="bg-light-1 py-4 dark:bg-dark-1 flex flex-wrap items-center justify-center xl:flex-row">
            {/* <ClubsMap /> */}
            {data.map((club) =>
              // If club.status == active, then show the club
              club.status === "Active" ? (
                <LinkCard
                  link={club.stub}
                  name={club.name}
                  img={club.logo.md}
                  rink={club.home}
                  col1={club.primary_color}
                  col2={club.secondary_color}
                />
              ) : (
                <></>
              )
            )}
          </div>
        }
      />
    </div>
  );
};
export default ClubsHero;
